import { Language } from '@altify/utils';
import { timeFrames } from 'data/time-frames';
import { Process } from 'types/otp';

import { Popular as categoryPopular } from '../app/_authenticated/products/explore/assets/icons/categories/Popular';
import {Stocks as categoryStocks } from '../app/_authenticated/products/explore/assets/icons/categories/Stocks';
import { PrivateCredit as categoryPrivateCredit } from '../app/_authenticated/products/explore/assets/icons/categories/PrivateCredit';
import { Crypto as categoryCrypto } from '../app/_authenticated/products/explore/assets/icons/categories/Crypto';
import { CryptoBundles as categoryCryptoBundles } from '../app/_authenticated/products/explore/assets/icons/categories/CryptoBundles';
import { Commodities as categoryCommodities } from '../app/_authenticated/products/explore/assets/icons/categories/Commodities';
import { Stablecoins as categoryStablecoins } from '../app/_authenticated/products/explore/assets/icons/categories/Stablecoins';

export const otpProcesses: { [key: string]: Process } = {
  WITHDRAW_FIAT: 'WITHDRAW_FIAT',
  WITHDRAW_CRYPTO_BTC: 'WITHDRAW_CRYPTO_BTC',
  WITHDRAW_CRYPTO_USDT: 'WITHDRAW_CRYPTO_USDT',
  WITHDRAW_CRYPTO_USDC: 'WITHDRAW_CRYPTO_USDC',
  SIGNUP_ENABLE_SMS_OTP: 'SIGNUP_ENABLE_SMS_OTP',
  PROFILE_ENABLE_SMS_OTP: 'PROFILE_ENABLE_SMS_OTP',
  PROFILE_CHANGE_PASSWORD: 'PROFILE_CHANGE_PASSWORD',
  PROFILE_BTC_WALLET: 'PROFILE_BTC_WALLET',
  PROFILE_USDT_WALLET: 'PROFILE_USDT_WALLET',
  PROFILE_USDC_WALLET: 'PROFILE_USDC_WALLET',
  PROFILE_BANK_DETAILS: 'PROFILE_BANK_DETAILS',
  SIGNUP_ENABLE_EMAIL_OTP: 'SIGNUP_ENABLE_EMAIL_OTP',
};

export const OTP_LENGTH = 6;

export const otpInterval = 90;

export const maxFileUploadSize = 4500000;

export const maxMobileNumberLength = 12;

export const signupOtpSkipDelay = 5000;

export const acceptedFileUploadFormats = ['jpeg', 'jpg', 'png', 'pdf', 'docx'];

export const productExploreTabsKeys = [
  'all',
  'stock',
  'privatecredit',
  'crypto',
  'bundle',
  'commodities',
  'stablecoin',
] as const;

export type ProductExploreTabKey = (typeof productExploreTabsKeys)[number];

export const productExploreTabs = {
  en: [
    { value: 'all', label: 'Popular', selectedLabel: 'Popular', className: 'bg-white border-neutral-600', activeClassName: 'active:bg-white', textClassName: 'text-neutral-600', icon: categoryPopular, iconClassName: 'border border-neutral-600 rounded-full' },
    { value: 'stock', label: 'Stocks', selectedLabel: 'Stocks', className: 'bg-[#8952FF] border-white', activeClassName: 'active:bg-[#8952FF]', textClassName: 'text-white', icon: categoryStocks, iconClassName: 'border border-white rounded-full' },
    { value: 'privatecredit', label: 'Private Credit', selectedLabel: 'Private Credit', className: 'bg-[#C6B17A] border-white', activeClassName: 'active:bg-[#C6B17A]', textClassName: 'text-white', icon: categoryPrivateCredit, iconClassName: 'border border-white rounded-full' },
    { value: 'crypto', label: 'Crypto', selectedLabel: 'Crypto', className: 'bg-primary border-white', activeClassName: 'active:bg-primary', textClassName: 'text-white', icon: categoryCrypto, iconClassName: 'border border-white rounded-full' },
    { value: 'bundle', label: 'Crypto Bundles', selectedLabel: 'Bundles', className: 'bg-[#1750F3] border-white', activeClassName: 'active:bg-[#1750F3]', textClassName: 'text-white', icon: categoryCryptoBundles, iconClassName: 'border border-white rounded-full' },
    { value: 'commodities', label: 'Commodities', selectedLabel: 'Commodities', className: 'bg-[#475873] border-white', activeClassName: 'active:bg-[#475873]', textClassName: 'text-white', icon: categoryCommodities, iconClassName: 'border border-white rounded-full' },
    { value: 'stablecoin', label: 'Stablecoins', selectedLabel: 'Stablecoins', className: 'bg-[#217A96] border-white', activeClassName: 'active:bg-[#217A96]', textClassName: 'text-white', icon: categoryStablecoins, iconClassName: 'border border-white rounded-full' },
  ],
  de: [
    { value: 'all', label: 'Beliebt', selectedLabel: 'Beliebt', className: 'bg-white border-neutral-600', activeClassName: 'active:bg-white', textClassName: 'text-white', icon: categoryPopular, iconClassName: 'border border-neutral-600 rounded-full' },
    { value: 'stock', label: 'Aktien', selectedLabel: 'Aktien', className: 'bg-[#8952FF] border-white', activeClassName: 'active:bg-[#8952FF]', textClassName: 'text-white', icon: categoryStocks, iconClassName: 'border border-white rounded-full' },
    { value: 'privatecredit', label: 'Privatkredit', selectedLabel: 'Privatkredit', className: 'bg-[#C6B17A] border-white', activeClassName: 'active:bg-[#C6B17A]', textClassName: 'text-white', icon: categoryPrivateCredit, iconClassName: 'border border-white rounded-full' },
    { value: 'crypto', label: 'Krypto', selectedLabel: 'Krypto', className: 'bg-primary border-white', activeClassName: 'active:bg-primary', textClassName: 'text-white', icon: categoryCrypto, iconClassName: 'border border-white rounded-full' },
    { value: 'bundle', label: 'Krypto-Bundles', selectedLabel: 'Bundles', className: 'bg-[#1750F3] border-white', activeClassName: 'active:bg-[#1750F3]', textClassName: 'text-white', icon: categoryCryptoBundles, iconClassName: 'border border-white rounded-full' },
    { value: 'commodities', label: 'Waren', selectedLabel: 'Waren', className: 'bg-[#475873] border-white', activeClassName: 'active:bg-[#475873]', textClassName: 'text-white', icon: categoryCommodities, iconClassName: 'border border-white rounded-full' },
    { value: 'stablecoin', label: 'Stablecoins', selectedLabel: 'Stablecoins', className: 'bg-[#217A96] border-white', activeClassName: 'active:bg-[#217A96]', textClassName: 'text-white', icon: categoryStablecoins, iconClassName: 'border border-white rounded-full' },
  ],
} satisfies {
  [K in Language]: {
    label: string;
    selectedLabel: string;
    value:
      | 'all'
      | 'privatecredit'
      | 'crypto'
      | 'bundle'
      | 'commodities'
      | 'stock'
      | 'stablecoin';
    className: string;
    activeClassName: string;
    textClassName: string;
    iconClassName: string;
    icon: any;
  }[];
};

export const privateCreditProductTabs = {
  en: [
    { value: 'overview', label: 'Overview' },
    { value: 'benefits', label: 'Benefits' },
    { value: 'structure', label: 'Structure' },
    { value: 'fees', label: 'Fees' },
    { value: 'disclosure', label: 'Risk Disclosure' },
  ],
  de: [
    { value: 'overview', label: 'Überblick' },
    { value: 'benefits', label: 'Vorteile' },
    { value: 'structure', label: 'Struktur' },
    { value: 'fees', label: 'Gebühren' },
    { value: 'disclosure', label: 'Risikohinweis' },
  ],
};

export const privateCreditProductCards = {
  en: [
    { value: 'yield', label: 'Annual Yield' },
    { value: 'noticePeriod', label: 'Notice Period' },
    { value: 'minimum', label: 'Min Investment' },
    { value: 'riskLevel', label: 'Risk Level' },
    { value: 'cashDistributions', label: 'Cash Distributions' },
    { value: 'maturity', label: 'Maturity' },
  ],
  de: [
    { value: 'yield', label: 'Jährlicher Ertrag' },
    { value: 'noticePeriod', label: 'Kündigungsfrist' },
    { value: 'minimum', label: 'Mindestanlage' },
    { value: 'riskLevel', label: 'Risikostufe' },
    { value: 'cashDistributions', label: 'Barausschüttungen' },
    { value: 'maturity', label: 'Reife' },
  ],
};

export const searchableListCategories = [
  // BA: This data will need to be replaced by this links(https://revix-dev-cdn-public.azureedge.net/data/page_config.json) response,
  {
    key: 'popular',
    label: {
      en: 'Most popular',
    },
  },
  {
    key: 'stablecoin',
    label: {
      en: 'Stablecoin',
    },
  },
  {
    key: '*',
    label: {
      en: 'All',
    },
  },
];
export const dropdownTimeframeOptions = Object.values(timeFrames);
export const productTypesForTabs: { [key in string]: string[] } = {
  crypto: ['crypto'],
  bundle: ['bundle'],
  commodities: ['commodity'],
  all: ['crypto', 'bundle', 'privatecredit', 'stablecoin', 'stock'],
  privatecredit: ['privatecredit'],
  stock: ['stock'],
  stablecoin: ['stablecoin'],
};

export const SSOMessages = {
  USER_DOES_NOT_EXIST: 'USER_DOES_NOT_EXIST',
  USER_SIGNED_UP_WITH_PASSWORD: 'USER_SIGNED_UP_WITH_PASSWORD',
  USER_SIGNED_UP_WITH_GOOGLE: 'USER_SIGNED_UP_WITH_GOOGLE',
  USER_SIGNED_UP_WITH_APPLE: 'USER_SIGNED_UP_WITH_APPLE',
};

export const loginTypes = {
  PASSWORD: 'PASSWORD',
  APPLE: 'APPLE',
  GOOGLE: 'GOOGLE',
};

export const dollarCurrencyCode = 'USD';
export const dollarCurrencySymbol = '$';
